export const ARRANGE_SEND = {
  BACK: 'back',
  FRONT: 'front',
  FORWARD: 'forward',
  BACKWARD: 'backward'
};

export const ARRANGE_FLIP = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
